<template>
  <div class="courseInfoSetting">
    <div class="componentTop">
      <div class="componentText">课程信息</div>
    </div>
    <div class="courseInfoMenu">
      <a-menu
        :selected-keys="[currentSelect]"
        mode="horizontal"
        @select="handleClick"
      >
        <a-menu-item key="1">课程信息</a-menu-item>
        <a-menu-item key="2">建课专家</a-menu-item>
      </a-menu>
      <div v-show="currentSelect === '1'" class="courseInfo">
        <div class="courseCover">
          <label for="">课程封面图:</label>
          <div class="group">
            <img :src="courseInfo.coverImg" alt="" />
            <a-upload
              name="file"
              :multiple="false"
              :action="imageUpload"
              :fileList="fileList"
              :remove="handleRemove"
              @change="handleChange"
              :beforeUpload="beforeUpload"
              accept=".png,.jpg,.jpeg"
            >
              <div class="btnGroup">
                <a-button> 更换 </a-button>
                <p>
                  说明：只支持png，jpeg，jpg格式，大小不超过1M，图片推荐比例16:9
                </p>
              </div>
            </a-upload>
          </div>
        </div>
        <div class="courseCover" v-show="false">
          <label for="">课程片头:</label>
          <div class="group">
            <div>
              <img :src="courseTitleInfo.coverUrl" alt="" />
              <p style="padding-left:15px;">{{ courseTitleInfo.titleName }}</p>
            </div>
            <div style="text-align:left;">
              <a-button
                @click="showTitleModal(courseTitleInfo)"
                style="margin-left:15px;"
              >
                更换
              </a-button>
              <p style="padding-left:15px;">该片头将在课程正式内容播放前播放</p>
            </div>
          </div>
        </div>
        <div class="courseIntro">
          <label for="" style="width: 85px;text-align: left">课程介绍:</label>
          <!--<a-input  type="textarea"-->
          <!--:max-length="500"-->
          <!--style="width: 450px"-->
          <!--v-model="courseInfo.intro"-->
          <!--:auto-size="{ minRows: 5, maxRows: 5 }"-->
          <!--/>-->
          <div
            ref="editorCon"
            style="text-align:left;flex: 1;width: 700px;z-index: 4"
          ></div>
        </div>
        <div class="bottomBtn">
          <a-button type="primary" @click="saveCourseInfo">保存</a-button>
        </div>
      </div>
      <div v-show="currentSelect === '2'" class="proficient">
        <!-- <div class="toolBtn">
                     <a-button type="primary" @click="addProficient">新增专家</a-button>
                 </div>-->
        <div class="proficientList">
          <a-list
            item-layout="vertical"
            size="large"
            :data-source="proficientList"
          >
            <a-list-item
              slot="renderItem"
              key="item.title"
              slot-scope="item, index"
            >
              <div class="proficientInfo">
                <div class="avatarInfo">
                  <img
                    width="150"
                    height="180"
                    style="object-fit: contain"
                    :src="item.expertPhoto
                        ? item.expertPhoto.includes('files2/deptAsistFile/notice/')
                        ? item.expertPhoto
                        : `https://vcg-yjyp-huadu-project-apply.oss-cn-shenzhen.aliyuncs.com/${item.expertPhoto.replace('https://eefiledownload.ttcn.cn', '')}`
                        : proficientDefault
                    "
                  />
                  <div class="info">
                    <p class="name limit">{{ item.expertName }}</p>
                    <p class="limit">
                      <!-- <span>单位:</span> --><span>{{
                        item.expertCompany
                      }}</span>
                    </p>
                    <div class="lastP">
                      <!-- <p>个人简介:</p> -->
                      <p v-html="item.expertDescribe"></p>
                      <div ref="editorDes" style="text-align:left"></div>
                    </div>
                  </div>
                </div>
                <!-- <div class="proficientBtnGroup">
                                       <a-button  @click="editProficientInfo(item)">编辑</a-button>
                                       <a-button  @click="deleteProficientInfo(item)">删除</a-button>
                                   </div>-->
              </div>
            </a-list-item>
          </a-list>
        </div>
        <!--抽屉-->
        <a-drawer
          :title="modelTitle"
          :width="730"
          @close="onClose"
          :visible="visible"
          :bodyStyle="{ paddingBottom: '80px' }"
        >
          <a-form-model
            :layout="drawFormLayout"
            :model="drawProficientForm"
            ref="proficientForm"
            :rules="rules"
          >
            <a-form-model-item label="专家姓名:" prop="expertName">
              <a-input
                v-model="drawProficientForm.expertName"
                :max-length="10"
              />
            </a-form-model-item>
            <a-form-model-item label="工作单位:" prop="expertCompany">
              <a-input
                v-model="drawProficientForm.expertCompany"
                :max-length="50"
              />
            </a-form-model-item>
            <a-form-model-item label="职称:">
              <a-input
                v-model="drawProficientForm.expertRank"
                :max-length="30"
              />
            </a-form-model-item>
            <a-form-model-item label="个人简介:">
              <!--<a-input v-model="drawProficientForm.expertDescribe" type="textarea"-->
              <!--:auto-size="{ minRows: 5, maxRows: 8 }"-->
              <!--/>-->
              <div ref="iniDescribe" style="text-align:left"></div>
            </a-form-model-item>
            <a-form-model-item label="个人照片:">
              <img
                :src="drawProficientForm.expertPhoto"
                alt=""
                style="width: 153px;height: 195px"
              />
              <a-upload
                name="file"
                :multiple="false"
                :action="imageUpload"
                :fileList="imgList"
                :remove="handleProficientRemove"
                accept=".jpeg,.jpg,.png,.bmp"
                @change="handleProficientChange"
              >
                <a-button style="margin-left: 10px">
                  <a-icon type="upload" />更换</a-button
                >
              </a-upload>
              <p style="font-size: 12px;color: #999999">
                注：若不更换，则显示默认照片，照片支持jpg、jpeg、png、bmp格式，大小少于1M
              </p>
            </a-form-model-item>
          </a-form-model>
          <div
            :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right',
              zIndex: 1,
            }"
          >
            <a-button :style="{ marginRight: '8px' }" @click="onClose">
              取消
            </a-button>
            <a-button @click="handleSubmit()" type="primary">确定</a-button>
          </div>
        </a-drawer>
      </div>
    </div>
    <a-modal v-model="courseTitlevisible" title="课程片头列表" :width="900">
      <a-table
        v-if="courseTitlevisible"
        :pagination="pagination"
        @change="handleTableChange"
        :columns="columns"
        :data-source="courseTitleList"
      >
        <template slot="coverUrl" slot-scope="coverUrl">
          <img :src="coverUrl" alt="" width="110" height="60" />
        </template>
        <template slot="subtitleContent" slot-scope="subtitleContent">
          <p style="white-space:pre-line;">{{ subtitleContent }}</p>
        </template>
        <template slot="courseSum" slot-scope="courseSum">
          <p>{{ courseSum }} 门</p>
        </template>
        <template slot="caozuo" slot-scope="text, record">
          <a-button type="link" @click="changeTitle(record)">选择</a-button>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import E from "wangeditor";
const columns = [
  {
    title: "片头名称",
    dataIndex: "titleName",
  },
  {
    title: "视频素材",
    dataIndex: "coverUrl",
    scopedSlots: { customRender: "coverUrl" },
  },
  {
    title: "字幕元素",
    dataIndex: "subtitleContent",
    scopedSlots: { customRender: "subtitleContent" },
  },
  {
    title: "应用课程数",
    dataIndex: "courseSum",
    scopedSlots: { customRender: "courseSum" },
  },
  {
    title: "创建时间",
    dataIndex: "createdDt",
  },
  {
    title: "操作",
    dataIndex: "caozuo",
    scopedSlots: { customRender: "caozuo" },
  },
];
export default {
  name: "courseInfoSetting",
  data() {
    return {
      columns,
      //专家上传
      imgList: [], //图片列表
      //抽屉表单
      proId: "", //专家id
      drawFormLayout: "horizontal",
      drawProficientForm: {
        expertName: "", // 专家姓名
        expertCompany: "", //工作单位
        expertRank: "", //职称
        expertDescribe: "", //简介
        expertPhoto: require("../../../../static/images/proficient_default.png"), //照片地址
        updatedBy: "更新人",
        createdBy: "创建者",
      },
      rules: {
        expertName: [
          { required: true, message: "专家姓名必填!", trigger: "blur" },
          { max: 10, message: "超出最大字符长度10", trigger: "blur" },
        ],
        expertCompany: [
          { required: true, message: "工作单位必填!", trigger: "blur" },
          { max: 100, message: "超出最大字符长度100", trigger: "blur" },
        ],
        expertDescribe: [
          { required: true, message: "个人简介必填!", trigger: "blur" },
          { max: 500, message: "超出最大字符长度500", trigger: "blur" },
        ],
      },
      //抽屉
      modelTitle: "新增专家",
      visible: true,
      //专家
      proficientDefault: require("../../../../static/images/proficient_default.png"),
      proficientList: [],
      //上传
      fileList: [],
      imageUpload: "",
      //课程
      courseInfo: {
        intro: "",
        coverImg: require("../../../../static/images/courseInfo_cover_default.png"),
      },
      defaultCoverImg: require("../../../../static/images/courseInfo_cover_default.png"),
      currentSelect: "1",
      introduceId: "", //当前课程id
      editor: null, //编辑器
      editorDescribe: null, //个人简介编辑器
      expertDescribeEditor: null, //新增,编辑个人简介编辑,
      courseTitleInfo: {},
      courseTitlevisible: false,
      courseTitleList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
        // showSizeChanger: true,
        showTotal: (total) => `共有 ${total} 条`, // 显示总数
        // pageSizeOptions: ['10', '20', '30', '40', '50']
      },
    };
  },
  mounted() {
    this.imageUpload =
      this.apis.upload.apiUpload + this.appUtils.getResearchId();
    this.getIntroduceId();
    this.getCourseTitleInfo();
    this.initEdit();
    this.visible = false;
  },
  methods: {
    changeTitle(item) {
      let that = this;
      this.$confirm({
        title: `您确定要更换片头 ${item.titleName} 吗?`,
        onOk() {
          that.saveCourseTitle(item);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    handleTableChange(pagination) {
      this.pagination.pageSize = pagination.pageSize;
      this.pagination.currentPage = pagination.current;
      this.getCourseTitleList();
    },
    saveCourseTitle(item) {
      let url = this.apis.courseInfoSetting.saveCourseTitle;
      this.http
        .post(url, {
          researchId: this.appUtils.getResearchId(),
          titleId: item.titleId,
          titleName: item.titleName,
          titleUrl: item.titleUrl,
          coverUrl: item.coverUrl,
          subtitleContent: item.subtitleContent,
          subtitleStartTime: item.subtitleStartTime,
          subtitleEndTime: item.subtitleEndTime,
          subtitlePosition: item.subtitlePosition,
          status: 1,
          mediaId: item.mediaId,
          runId: item.runId,
        })
        .then((res) => {
          this.$message.success("更换片头成功");
          this.getCourseTitleInfo();
          this.courseTitlevisible = false;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.messgae);
        });
    },
    getCourseTitleList() {
      let url = this.apis.courseInfoSetting.getCourseTitleList;
      this.http
        .post(url, {
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          where: {
            titleName_like: "",
            status_eq: 1,
          },
        })
        .then((res) => {
          this.courseTitleList = res.data;
          this.pagination.total = res.pageInfo.totalCount;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showTitleModal() {
      this.getCourseTitleList();
      this.courseTitlevisible = true;
    },
    initEdit() {
      this.editor = new E(this.$refs.editorCon);
      this.editor.customConfig.onchange = (html) => {
        this.courseInfo.intro = html;
      };
      this.editor.create();
      this.editor.$textElem.attr("contenteditable", false);
      this.editor.$textElem.addClass("contenteditable");
    },
    initEdit2() {
      console.log(this.$refs.editorDes);
      console.log(this.editorDescribe);
      if (this.editorDescribe === null) {
        this.editorDescribe = new E(this.$refs.editorDes);
        this.editorDescribe.customConfig.onchange = (html) => {
          //this.courseInfo.intro = html;
        };
        this.editorDescribe.create();
        this.editorDescribe.$textElem.attr("contenteditable", false);
        this.editorDescribe.$textElem.addClass("contenteditable");
      }
    },
    initExpertDescribe() {
      console.log(this.$refs.iniDescribe);
      if (this.expertDescribeEditor === null) {
        this.expertDescribeEditor = new E(this.$refs.iniDescribe);
        this.expertDescribeEditor.customConfig.onchange = (html) => {
          this.drawProficientForm.expertDescribe = html;
        };
        this.expertDescribeEditor.create();
      }
    },
    getIntroduceId() {
      let url =
        this.apis.courseInfoSetting.getIntroduceList +
        this.appUtils.getResearchId();
      this.http
        .get(url)
        .then((res) => {
          this.introduceId = res.data[0].introduceId;
          this.getCourseInfo();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCourseTitleInfo() {
      let url =
        this.apis.courseInfoSetting.getCourseTitleInfo +
        this.appUtils.getResearchId();
      this.http
        .get(url)
        .then((res) => {
          this.courseTitleInfo = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    ProficientUpload(file) {
      if (file.size / 1048576 > 1) {
        this.$message.error("超出附件大小!");
        return false;
      }
      if (
        file.type.indexOf("png") > 0 ||
        file.type.indexOf("jpg") > 0 ||
        file.type.indexOf("jpeg") > 0 ||
        file.type.indexOf("bmp") > 0
      ) {
        // console.log("执行上传");
      } else {
        this.$nextTick(function() {
          this.imgList = [];
        });
        this.$message.error("上传文件不符");
        return false;
      }
      this.imgList = [...this.imgList, file];
      if (this.imgList.length > 1) {
        this.imgList.splice(1, 1);
      }
    },
    handleProficientRemove(file) {
      let index = this.imgList.indexOf(file);
      let newFileList = this.imgList.slice();
      newFileList.splice(index, 1);
      this.imgList = newFileList;
      this.drawProficientForm.expertPhoto = this.proficientDefault;
    },
    handleProficientChange(res) {
      if (res.file) {
        let fileList = [...res.fileList];
        fileList = fileList.slice(-1);
        this.imgList = fileList;
        if (res.file.status === "done") {
          this.$message.success("图片上传成功!");
          this.drawProficientForm.expertPhoto = this.imgList[0].response.transcodedFileUrl;
        } else if (res.file.status === "error") {
          this.$message.error(`${res.file.name} file upload failed.`);
        }
      }
    },
    //表单提交操作
    handleSubmit() {
      let temp = {
        ...this.drawProficientForm,
      };
      temp.expertPhoto =
        temp.expertPhoto.indexOf("/proficient_default") === -1
          ? temp.expertPhoto
          : "";
      this.$refs.proficientForm.validate((valid) => {
        if (valid) {
          if (this.modelTitle === "编辑专家") {
            temp.id = this.proId;
            this.putProficient(temp);
          } else {
            temp.courseId = this.appUtils.getResearchId();
            this.postProficient(temp);
          }
          console.log(temp);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onClose() {
      this.visible = false;
      this.resetForm();
    },
    resetForm() {
      this.$refs.proficientForm.resetFields();
      this.drawProficientForm.expertRank = "";
    },
    deleteProficientInfo(item) {
      let that = this;
      this.$confirm({
        title: "您确定要删除当前专家?",
        onOk() {
          console.log(item);
          that.deleteProficient(item.id);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    editProficientInfo(item) {
      this.modelTitle = "编辑专家";
      this.visible = true;
      this.proId = item.id;
      this.getProficient(item);
      this.initExpertDescribe();
    },
    addProficient() {
      this.modelTitle = "新增专家";
      this.visible = true;
      this.drawProficientForm.expertDescribe = "";
      if (this.expertDescribeEditor !== null) {
        this.expertDescribeEditor.txt.html(``);
      }
      this.initExpertDescribe();
    },
    saveCourseInfo() {
      let temp = {
        ...this.courseInfo,
      };
      temp.coverImg =
        temp.coverImg.indexOf("img/courseInfo_cover_default") === -1
          ? temp.coverImg
          : "";
      let params = {
        researchDesc: temp.intro,
        coverImage: temp.coverImg,
      };
      console.log(params);
      this.putCourseInfo(params);
    },
    //课程信息图片上传
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
      this.courseInfo.coverImg = this.defaultCoverImg;
    },
    beforeUpload(file, fileList) {
      if (file.size / 1048576 > 1) {
        this.$message.error("超出附件大小!");
        return false;
      }
      if (
        file.type.indexOf("png") > 0 ||
        file.type.indexOf("jpg") > 0 ||
        file.type.indexOf("jpeg") > 0
      ) {
        // console.log("执行上传");
      } else {
        fileList = [];
        this.$nextTick(function() {
          this.fileList = [];
        });
        this.$message.error("上传文件不符");
        return false;
      }
      this.fileList = [...this.fileList, file];
      if (this.fileList.length > 1) {
        this.fileList.splice(1, 1);
      }
    },
    handleChange(res) {
      if (res.file) {
        let fileList = [...res.fileList];
        fileList = fileList.slice(-1);
        this.fileList = fileList;
        if (res.file.status === "done") {
          this.$message.success("图片上传成功!");
          // this.courseInfo.coverImg=this.fileList[0].response.transcodedFileUrl;
          this.courseInfo.coverImg =
            this.apis.upload.aliyuncs +
            "/" +
            this.fileList[0].response.data.filePath;
        } else if (res.file.status === "error") {
          this.$message.error(`${res.file.name} file upload failed.`);
        }
      }
    },
    handleClick(e) {
      this.currentSelect = e.key;
      if (this.currentSelect === "1") {
        this.getCourseInfo();
      } else {
        this.getProficientList();
        // this.initEdit2();
        console.log(111);
      }
      console.log(112);
    },
    getCourseInfo() {
      this.http
        .get(this.apis.courseInfoSetting.getCourseInfo + this.introduceId)
        .then((res) => {
          if (res.status === 0) {
            if (
              res.data.coverImage == "" ||
              res.data.coverImage == undefined ||
              res.data.coverImage == null
            ) {
              this.courseInfo.coverImg = this.defaultCoverImg;
            } else {
              this.courseInfo.coverImg = res.data.coverImage;
            }
            // this.courseInfo.intro=res.data.researchDesc.replace(/<[^<>]+>/g,'');
            this.courseInfo.intro = res.data.researchDesc;
            this.editor.txt.html(`${this.courseInfo.intro}`);
          }
        })
        .catch((err) => {
          this.$message.error("请求失败");
        });
    },
    putCourseInfo(params) {
      this.http
        .put(
          this.apis.courseInfoSetting.getCourseInfo + this.introduceId,
          params
        )
        .then((res) => {
          if (res.status === 0) {
            this.$message.success("保存成功");
            this.getProficientList();
          }
        })
        .catch((err) => {
          this.$message.error("请求失败");
        });
    },
    async getProficientList() {
      let params = {
        researchId: this.appUtils.getResearchId(),
      };
      this.http
        .get(this.apis.courseInfoSetting.getProficientList, params)
        .then((res) => {
          if (res.status === 0) {
            console.log(res);
            this.proficientList = res.data;
            // this.initEdit2();
          }
        })
        .catch((err) => {
          this.$message.error("请求失败");
          console.log(err);
        });
    },
    postProficient(params) {
      this.http
        .post(this.apis.courseInfoSetting.postProficient, params)
        .then((res) => {
          if (res.status === 0) {
            this.visible = false;
            this.resetForm();
            this.getProficientList();
            this.$message.success("新增成功");
          }
        })
        .catch((err) => {
          this.$message.error("请求失败");
        });
    },
    putProficient(params) {
      this.http
        .post(this.apis.courseInfoSetting.postProficient, params)
        .then((res) => {
          if (res.status === 0) {
            this.visible = false;
            this.resetForm();
            this.getProficientList();
            this.$message.success("修改成功");
          }
        })
        .catch((err) => {
          this.$message.error("请求失败");
        });
    },
    getProficient(item) {
      let params = {
        expertId: item.id,
      };
      this.http
        .get(this.apis.courseInfoSetting.getProficient, params)
        .then((res) => {
          if (res.status === 0) {
            this.drawProficientForm = res.data[0];
            if (res.data[0].expertPhoto === "") {
              this.drawProficientForm.expertPhoto = this.proficientDefault;
            } else {
              this.drawProficientForm.expertPhoto = res.data[0].expertPhoto;
            }
            this.drawProficientForm.expertDescribe = res.data[0].expertDescribe;
            this.expertDescribeEditor.txt.html(
              `${this.drawProficientForm.expertDescribe}`
            );
          }
        })
        .catch((err) => {
          this.$message.error("请求失败");
        });
    },
    deleteProficient(id) {
      this.http
        .delete(this.apis.courseInfoSetting.deleteProficient + id)
        .then((res) => {
          if (res.status === 0) {
            this.getProficientList();
            this.$message.success("删除成功");
          }
        })
        .catch((err) => {
          this.$message.error("请求失败");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.courseInfoSetting {
  /deep/.contenteditable:hover {
    cursor: not-allowed !important;
  }
  /deep/.w-e-text-container {
    height: 450px !important;
  }
  .componentTop {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px 0 40px;
    .componentText {
      font-size: 30px;
      color: #333333;
    }
  }
  .courseInfoMenu {
    .courseInfo {
      margin-top: 45px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 100px;
      & > div > label {
        width: 80px;
        text-align: right;
      }
      .courseCover {
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
        .group {
          display: flex;
          width: 450px;
          img {
            margin-left: 15px;
            width: 225px;
            height: 130px;
          }
          .btnGroup {
            min-width: 150px;
            margin-left: 10px;
            button {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          p {
            text-align: left;
            margin-top: 8px;
            color: #999999;
            font-size: 12px;
          }
        }
      }
      .courseIntro {
        margin-top: 30px;
        display: flex;
        justify-content: center;
      }
      .bottomBtn {
        margin-top: 35px;
        width: 700px;
      }
    }
    .proficient {
      .toolBtn {
        display: flex;
        justify-content: flex-end;
        margin: 15px 0;
        button {
          margin-right: 50px;
        }
      }
      .proficientList {
        padding: 20px;
        .proficientInfo {
          display: flex;
          justify-content: space-between;
          .avatarInfo {
            display: flex;
            .info {
              flex: 1;
              margin-left: 40px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .limit {
                color: #666666;
                max-width: 500px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 5px !important;
              }
              .name {
                color: #000000;
                font-size: 16px;
              }
              .lastP {
                display: flex;
                p:first-child {
                  // width: 62px;
                  // min-width: 62px;
                  text-align: left;
                }
                p:last-child {
                  text-align: left;
                }
              }
            }
          }
          .proficientBtnGroup {
            min-width: 150px;
            button:first-child {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
